// DSH-00 / GEN-10 — the four Dashboard views, in menu order. Each view is its
// own route and its own permission key (backend PERMISSION_TREE, category
// `dashboard`). One list drives the left menu, the view switch at the top of each
// view, the landing redirect and the 'no access' gate, so they cannot disagree.
import { Store, Building2, Briefcase, LineChart } from 'lucide-react';
import type { NavNode } from '@/components/layout/navTree';
import type { PermissionKey } from '@/lib/auth/permission-keys';

export type DashboardViewId = 'outlet' | 'office' | 'management' | 'business';

export interface DashboardView {
  id: DashboardViewId;
  /** Path without locale. */
  path: string;
  permission: PermissionKey;
  /** Key in the `nav` namespace (menu) and `dashboard` namespace (switch). */
  labelKey: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const DASHBOARD_VIEWS: DashboardView[] = [
  { id: 'outlet', path: '/dashboard/outlet', permission: 'dashboard.outlet', labelKey: 'dashboardOutletView', icon: Store },
  { id: 'office', path: '/dashboard/office', permission: 'dashboard.office', labelKey: 'dashboardOfficeView', icon: Building2 },
  { id: 'management', path: '/dashboard/management', permission: 'dashboard.management', labelKey: 'dashboardManagementView', icon: Briefcase },
  { id: 'business', path: '/dashboard/business', permission: 'dashboard.business', labelKey: 'dashboardBusinessOverview', icon: LineChart },
];

/** GEN-10-02: the left menu under Dashboard. Each leaf shows only for holders of its key. */
export const DASHBOARD_VIEW_NAV: NavNode[] = DASHBOARD_VIEWS.map((view) => ({
  id: `dashboard-${view.id}`,
  labelKey: view.labelKey,
  icon: view.icon,
  href: view.path,
  anyKey: [view.permission],
}));
